import { useCallback, useMemo } from 'react';

import * as events from 'src/lib/events';
import { useTrackingEvent } from 'src/services/useTrackingEvent';

import { useLocalActions } from '../../store';

export function useEvents() {
  const trackEvent = useTrackingEvent();
  const localActions = useLocalActions();

  const trackMultiPromptChangeBrief = useCallback(() => {
    trackEvent(events.DOCUMENT.multiPromptChangeBrief, {});
  }, [trackEvent]);

  const trackResourceInserted = useCallback(
    (type, widget) => {
      trackEvent(events.PROMPTS.promptResourceInserted, {
        page: events.EVENT_PAGE.prompts,
        generationTool: localActions.getGenerationTool(),
        type,
        widget,
      });
    },
    [localActions, trackEvent]
  );

  return useMemo(
    () => ({
      trackMultiPromptChangeBrief,
      trackResourceInserted,
    }),
    [trackMultiPromptChangeBrief, trackResourceInserted]
  );
}
